const loadingActions = {
	start(message) {
		return { type: 'LOADING_START' };
	},
	 
	end(message) {
		return { type: 'LOADING_END' };
	}
}

export default loadingActions;



// WEBPACK FOOTER //
// ./src/actions/loadingActions.js